import _ from "lodash";
import moment from "moment";


export const moodToValue = (mood) => {
    const moodMap = {
        VERY_BAD: 1,
        BAD: 2,
        GOOD: 3,
        VERY_GOOD: 4,
        PERFECT: 5,
    };
    return moodMap[mood] || null;
};

export const balanceToValue = (balance) => {
    const balanceMap = {
        BAD: 1,
        BEARABLE: 2,
        IMPACT_BALANCE: 3,
        PERFECT: 4,
    };
    return balanceMap[balance] || null;
};

export const getMonthData = (monthIndex, year) => {
    const date = moment(new Date(year, monthIndex, 1));
    return {
        result: date.format("MM/YY"),
        tooltipDate: date.format("MMMM YYYY"),
        month: date.month() + 1,
        year: date.year(),
    };
};

export const formatSatisfactionData = (satisfactionData, year = new Date().getFullYear()) => {
    return _.range(12).map((monthIndex) => {
        const data = getMonthData(monthIndex, year);
        const result = _.find(
            satisfactionData,
            (p) => p.satisfaction_date_month === data.month && p.satisfaction_date_year === data.year
        );

        return {
            date: data.result,
            tooltipDate: data.tooltipDate,
            satisfaction: result ? moodToValue(result.mood) : null,
            equilibrium: result ? balanceToValue(result.balance) : null,
        };
    });
};


export const getSatisfactionResult = (val, intl) => {
    switch (val) {
        case 1:
            return intl.formatMessage({
                id: "very_bad",
                defaultMessage: "Très mauvaise",
            });
        case 2:
            return intl.formatMessage({
                id: "bad",
                defaultMessage: "Mauvaise",
            });
        case 3:
            return intl.formatMessage({
                id: "good",
                defaultMessage: "Bonne",
            });
        case 4:
            return intl.formatMessage({
                id: "very_good",
                defaultMessage: "Très bonne",
            });
        case 5:
            return intl.formatMessage({
                id: "perfect",
                defaultMessage: "Parfaite",
            });
    }
};

export const getEquilibriumResult = (val, intl) => {
    switch (val) {
        case 1:
            return intl.formatMessage({
                id: "bad",
                defaultMessage: "Mauvaise",
            });

        case 2:
            return intl.formatMessage({
                id: "bearable",
                defaultMessage: "Supportable",
            });

        case 3:
            return intl.formatMessage({
                id: "impact_balance",
                defaultMessage: "Équilibré",
            });

        case 4:
            return intl.formatMessage({
                id: "perfect",
                defaultMessage: "Parfait",
            });
    }
};